import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { tap } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Platform } from '@angular/cdk/platform';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BreadcrumbsService, MenuItem } from '../services/breadcrumbs.service';
import { DOCUMENT } from '@angular/common';
import { CustomWindow } from '../services/analytics.service';

@UntilDestroy()
@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  styleUrls: ['./page.component.scss']
})
export class PageComponent implements OnInit {

  public organization: string;
  public isHideHeader = false;

  constructor(
    public platform: Platform,
    private route: ActivatedRoute,
    private router: Router,
    private breadcrumbsService: BreadcrumbsService,
    @Inject(DOCUMENT) private readonly documentRef: Document,
    @Inject(Window) private window: CustomWindow,
  ) {
  }

  ngOnInit(): void {
    this.route.paramMap.pipe(
      untilDestroyed(this),
      switchMap(params => params.getAll('organizationId')),
      tap(organization => {
        this.organization = organization;
      })
    ).subscribe({
      next: response => response,
      error: () => this.router.navigate(['oops'])
    });
    this.breadcrumbsService.breadcrumbs.pipe().subscribe(menuItems => {
      this.initRoute(menuItems);
    });
    this.initRoute(this.breadcrumbsService.breadcrumbsSnapshot);

    // Есть косяк на мобилках, что они некорректно отдают высоту экрана. Ниже костыль, который это решает
    // по ссылке то, откуда взял решение
    // https://css-tricks.com/the-trick-to-viewport-units-on-mobile/
    // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
    let vh = this.window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    this.documentRef.documentElement.style.setProperty('--vh', `${vh}px`);
    // We listen to the resize event
    this.window.addEventListener('resize', () => {
      // We execute the same script as before
      let vh = this.window.innerHeight * 0.01;
      this.documentRef.documentElement.style.setProperty('--vh', `${vh}px`);
    });
  }

  initRoute(menuItems: MenuItem[]) {
    let activeRoute = menuItems[menuItems.length - 1];
    this.isHideHeader = activeRoute.isHideHeader;
  }
}
